import {
  Button,
  FormControl,
  Grid,
  TextField
} from "@mui/material";
import { makeStyles } from '@mui/styles';
import Container from "@mui/material/Container";
import { useState } from "react";
import AuthService from "./services/authService";

const initialUserState = {
  email: "",
  password: "",
};

const Register = () => {
  const [formData, setFormData] = useState(initialUserState);
  const [isLoading, setIsLoading] = useState(false);

  const submitForm = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    await AuthService.addUser(formData.email, formData.password);
    await AuthService.sendEmail(formData.email);
    setFormData(initialUserState);
    setIsLoading(false);
  };

  const handleChange = (e) => {
    let { value, name } = e.target;

    setFormData({ ...formData, [name]: value });
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    formControl: {
      margin: theme.spacing(1),
    },
  }));

  const classes = useStyles();

  return (
    <Container maxWidth="md">
      <Grid container justifyContent="center">
        <Grid
          item
          xs={9}
          sm={6}
          md={4}
          style={{
            textAlign: "center",
            marginTop: "40px",
            marginBottom: "40px",
          }}
        >
          <form
            className={classes.root}
            onSubmit={submitForm}
            autoComplete="off"
            noValidate
            style={{ width: "100%" }}
          >
            <FormControl className={classes.formControl} fullWidth>
              <TextField
                label="Email"
                name="email"
                id="email-input"
                onChange={handleChange}
                value={formData.email}
              />
            </FormControl>
            <FormControl className={classes.formControl} fullWidth>
              <TextField
                label="Password"
                name="password"
                type="password"
                id="password-input"
                onChange={handleChange}
                value={formData.password}
              />
            </FormControl>
            <FormControl className={classes.formControl} fullWidth>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={isLoading}
              >
                Register
              </Button>
            </FormControl>
          </form>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Register;
